import React from 'react';
import HomeFourMain from './HomeFourMain';
import FooterTwo from '../../components/Footer/FooterTwo';
import HeaderFour from '../../components/Header/HeaderFour';

import Logo from '../../assets/img/logo/logo-white-4.png';

const HomeFour = () => {
  return (
    <>
      <HeaderFour />

      <HomeFourMain />

      <FooterTwo
        footerClass="it-footer-area it-footer-style-2 it-footer-style-3 it-footer-style-4 black-bg p-relative fix z-index p-relative"
        footerLogo={Logo}
        copyrightClass="it-copyright-area it-copyright-height it-copyright-style-2 it-copyright-style-3"
      />
    </>
  );
};

export default HomeFour;
